import { render, staticRenderFns } from "./AddCommunityManager.vue?vue&type=template&id=7e50d060&scoped=true&"
import script from "./AddCommunityManager.vue?vue&type=script&lang=js&"
export * from "./AddCommunityManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e50d060",
  null
  
)

export default component.exports